var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-50"},[_c('v-modal-container',{attrs:{"modals":_vm.modals},on:{"close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }